export default "__VITE_ASSET__CBxfBnWB__"